﻿import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Constant from 'utils/constants';
import strings from 'assets/strings';
import styleVars_15 from "styles/colors.module.scss";
const { turquoise01  } = styleVars_15;;

import { TaskListIcon } from 'components/Icon';
import Button from 'components/Button';

import * as taskWidgets from 'containers/TaskWidget';
import { useSupportedTasks } from 'helpers/tasks';
import theme from "./TaskList.module.sass";

const TASK_MAPPING = {
  [Constant.task.action.publishTreatmentPlan]:
    taskWidgets.PublishTreatmentPlanWidget,
  [Constant.task.action.acceptRejectTreatmentPlan]:
    taskWidgets.ReviewTreatmentPlanWidget,
  [Constant.task.action.acceptRejectProgram]:
    taskWidgets.AcceptRejectProgramWidget,
  [Constant.task.action.publishStage]: taskWidgets.PublishStageWidget,
  [Constant.task.action.startAcneProgram]: taskWidgets.StartProgramWidget,
  [Constant.task.action.completeSurveyResponse]:
    taskWidgets.CompleteSurveyWidget,
  [Constant.task.action.selectAcneSeverityRating]: taskWidgets.SelectASRWidget,
  [Constant.task.action.watchVideo]: taskWidgets.WatchVideoWidget,
  [Constant.task.action.consentToAcneProgram]: taskWidgets.ConsentProgramWidget,
};

const TaskList = ({ tasks: allTasks = [], title = strings.tasks, truncateSize = 5 }) => {
  // Tasks with no widget are left out and reported rather than thrown; see
  // helpers/tasks.jsx for why, and for the signal that replaced the throw.
  const tasks = useSupportedTasks(allTasks, TASK_MAPPING, 'TaskListWidget');
  const [showAllTasks, setShowAllTasks] = useState(false);
  const shownTasks = showAllTasks ? tasks : tasks.slice(0, truncateSize);

  const renderTask = (task, index) => {
    const TaskWidget = TASK_MAPPING[task.action];
    return <TaskWidget key={index} task={task} />;
  };

  return (
    <div>
      <div className={theme.Title}>
        <TaskListIcon fill={turquoise01} />
        <h1>{`${title} (${tasks.length})`}</h1>
      </div>
      {tasks.length === 0 && <h1 className={theme.Empty}>No tasks found</h1>}
      <ul className={theme.List}>{shownTasks.map(renderTask)}</ul>
      {!showAllTasks && tasks.length > truncateSize && (
        <Button
          classes={[theme.Link]}
          color="sensitive"
          onClick={() => {
            setShowAllTasks(true);
          }}
        >
          View All
        </Button>
      )}
    </div>
  );
};

TaskList.propTypes = {
  tasks: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  truncateSize: PropTypes.number.isRequired,
};

export default TaskList;
